module.exports = __webpack_public_path__ + "img/Pic_Banner-1.a6b9ab54.jpg";